module.exports = __webpack_public_path__ + "img/zhongchuan.dcd9892a.png";